// Client-side SEO/AEO head management for public pages.
export function injectSchema(list) {
  (list || []).forEach((data, i) => {
    const id = `aeo-schema-${i}`;
    let s = document.getElementById(id);
    if (!s) { s = document.createElement("script"); s.id = id; s.type = "application/ld+json"; document.head.appendChild(s); }
    s.textContent = JSON.stringify(data);
  });
}

export function setMeta(name, content, prop = false) {
  if (!content) return;
  const sel = prop ? `meta[property="${name}"]` : `meta[name="${name}"]`;
  let t = document.querySelector(sel);
  if (!t) { t = document.createElement("meta"); prop ? t.setAttribute("property", name) : t.setAttribute("name", name); document.head.appendChild(t); }
  t.setAttribute("content", content);
}

export function setCanonical(url) {
  if (!url) return;
  let l = document.querySelector('link[rel="canonical"]');
  if (!l) { l = document.createElement("link"); l.setAttribute("rel", "canonical"); document.head.appendChild(l); }
  l.setAttribute("href", url);
}
